






















































































import { Component, Vue } from "vue-property-decorator";
import { cloneDeep } from "lodash";
import moduleHeader from "@/components/moduleHeader/index.vue";
import { fetchProductList } from "@/api/portfolio";
import { starProductList, saveStarProduct } from "@/api/investProduct";
@Component({
  components: {
    moduleHeader,
  },
})
export default class StarProduct extends Vue {
  visible = false;

  itemArr: any = [
    {
      type: "FirstChoice",
      products: {
        productName: "首选产品",
        productArr: [],
        value: "",
      },
      startAmount: 1,
      stepAmount: 1,
    },
    {
      type: "AlternativeChoice",
      products: {
        productName: "备选产品",
        productArr: [],
        value: "",
      },
      startAmount: 1,
      stepAmount: 1,
    },
    {
      type: "AutomaticProduct",
      products: {
        productName: "定投产品",
        productArr: [],
        value: "",
      },
      startAmount: 1,
      stepAmount: 1,
    },
  ];
  cloneMapData = {};
  formArr = [
    { itemArr: cloneDeep(this.itemArr), name: "现金类" },
    { itemArr: cloneDeep(this.itemArr), name: "固收类" },
    { itemArr: cloneDeep(this.itemArr), name: "权益类" },
    { itemArr: cloneDeep(this.itemArr), name: "另类" },
  ];

  formArrCopy = [
    { itemArr: cloneDeep(this.itemArr), name: "现金类" },
    { itemArr: cloneDeep(this.itemArr), name: "固收类" },
    { itemArr: cloneDeep(this.itemArr), name: "权益类" },
    { itemArr: cloneDeep(this.itemArr), name: "另类" },
  ];

  show() {
    this.getData();
    this.visible = true;
  }

  async getStarProductList() {
    const { data } = await starProductList();
    this.cloneMapData = cloneDeep(data);
    for (const key in data) {
      this.formArr.forEach((item: any) => {
        // if (data[item.name]) {
        if (item.name === key) {
          data[key].forEach((_item: any) => {
            item.itemArr.forEach((w: any) => {
              if (w.type === _item.starProductType) {
                w.products.value = _item.productId;
                w.startAmount = _item.startAmount;
                w.stepAmount = _item.stepAmount;
              }
            });
          });
        }
      });
    }
  }

  async getData() {
    const res = await fetchProductList({ onSale: true, size: 1000 });

    const obj: any = {};
    res.data.content.forEach((item: any) => {
      if (!obj[item.rootTypeName]) {
        obj[item.rootTypeName] = [item];
      } else {
        obj[item.rootTypeName].push(item);
      }
    });
    this.formArr.forEach((item: any) => {
      if (obj[item.name]) {
        item.itemArr.forEach((w: any) => {
          // 定投产品 enableAutomaticInvest true 定投
          if (w.type === "AutomaticProduct") {
            w.products.productArr = obj[item.name].filter(
              (item: any) => item.enableAutomaticInvest
            );
          } else {
            w.products.productArr = obj[item.name];
          }
        });
      }
    });
    this.getStarProductList();
  }

  close() {
    this.formArr = this.formArrCopy;
    this.visible = false;
  }

  async confirm() {
    const _arr: any = [];
    for (let i = 0; i < this.formArr.length; i++) {
      const item = this.formArr[i];
      for (let j = 0; j < item.itemArr.length; j++) {
        const w = item.itemArr[j];
        if (w.stepAmount <= 0) {
          this.$message({
            type: "warning",
            message: "产品递投金额不得小于0",
          });
          return;
        }
        if (w.products.value) {
          const _product = w.products.productArr.find(
            (v: any) => v.id === w.products.value
          );

          if (_product) {
            let mapFind = this.cloneMapData[item.name]?.find(
              (v: any) =>
                v.starProductType === w.type && _product.id === v.productId
            );
            let obj = {
              ..._product,
              starProductType: w.type,
              rootTypeName: item.name,
              productId: _product.id,
              startAmount: +w.startAmount,
              stepAmount: +w.stepAmount,
            };
            delete obj.id;
            if (mapFind) {
              obj = {
                ...mapFind,
                startAmount: +w.startAmount,
                stepAmount: +w.stepAmount,
              };
            }
            _arr.push(obj);
          }
        }
      }
    }
    let _data = cloneDeep([..._arr])
    let _newData =[]
    let mapdate: any[] = []
    for (const k in this.cloneMapData) {
        this.cloneMapData[k].forEach((item: any) => {
          mapdate.push({...item, deleted: true})
        });
    }
    if(_data.length && mapdate.length) {

      let idxArr = []
      for (let i = 0; i < mapdate.length; i++) {
          const findIdx = _data.findIndex((item: any) =>(item.id === mapdate[i].id && !item.deleted))
          if(findIdx !== -1) {
            idxArr.push(findIdx)
            _newData.push({...mapdate[i],deleted: false})
          }else {
            _newData.push({...mapdate[i]})
          }
        }

        for (let i = 0; i < _data.length; i++) {
          if(!idxArr.includes(i)) {
            _newData.push({..._data[i]})
          }

        }
    }else if(_data.length) {
      _newData = [..._data]
    }else if(mapdate.length) {
      _newData = [...mapdate]
    }
    await saveStarProduct([..._newData]);
    this.visible = false;
    this.formArr = this.formArrCopy;
  }
}
